import React from 'react';

import BatteryStateOfCharge from './BatteryStateOfCharge';
import DistanceFromHome from './DistanceFromHome';
import FlightTimeElapsed from './FlightTimeElapsed';
import FlightTimeRemaining from './FlightTimeRemaining';
import FlightTimeToHome from './FlightTimeToHome';
import FlightTimeToRTH from './FlightTimeToRTH';
import GpsStatusIndicator from './GpsStatusIndicator';
import OrientationIndicator from './OrientationIndicator';
import WindDirectionIndicator from './WindDirectionIndicator';
import WindSpeedIndicator from './WindSpeedIndicator';

export interface FlightMetricsPanelProps {
  timeRemainingSec: number;
  timeToHomeSec: number;
  timeSinceTakeoffSec: number;
  distanceFromHomeM: number;
  batteryRemaining: number; // 0..1
  windSpeedMps: number;
  windDirectionDeg: number;
  headingDeg: number;
  pitchDeg: number;
  rollDeg: number;
  gpsReception: string;
  gpsFix: string;
}

const FlightMetricsPanel: React.FC<FlightMetricsPanelProps> = (props) => {
  const {
    timeRemainingSec,
    timeToHomeSec,
    timeSinceTakeoffSec,
    distanceFromHomeM,
    batteryRemaining,
    windSpeedMps,
    windDirectionDeg,
    headingDeg,
    pitchDeg,
    rollDeg,
    gpsReception,
    gpsFix
  } = props;

  return (
    <div className='space-y-2'>
      <div className='flex space-x-2'>
        <FlightTimeToRTH timeRemainingSec={timeRemainingSec} timeToHomeSec={timeToHomeSec} />
        <FlightTimeToHome seconds={timeToHomeSec} />
        <FlightTimeRemaining seconds={timeRemainingSec} batteryPercent={batteryRemaining} />
        <FlightTimeElapsed seconds={timeSinceTakeoffSec} />
      </div>
      <div className='flex space-x-2'>
        <DistanceFromHome meters={distanceFromHomeM} />
        <BatteryStateOfCharge remaining={batteryRemaining} />
        <WindSpeedIndicator metersPerSecond={windSpeedMps} />
        <WindDirectionIndicator degrees={windDirectionDeg} />
      </div>
      <OrientationIndicator heading={headingDeg} pitch={pitchDeg} roll={rollDeg} />
      <GpsStatusIndicator reception={gpsReception} fixState={gpsFix} />
    </div>
  );
};

export default FlightMetricsPanel;
